import React from "react";
import Modal from "react-modal";
import CustomPDFViewer from "./CustomPdfViewer";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxWidth: "95%", // Responsive for mobile
    zIndex: 1050,
    padding: "20px",
  },
  overlay: {
    zIndex: 1040,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

Modal.setAppElement("#root");

const ViewPdfModal = ({ isOpen, onRequestClose, contentLabel, pdfUrl }) => {

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={contentLabel}
    >
      <div className="w-lg h-screen">
        <CustomPDFViewer pdfUrl={pdfUrl} />
      </div>
    </Modal>
  );
};

export default ViewPdfModal;
